import Container from "../../components/ui/Container.js"
import "./CrosswordView.scss"

import { useSteps } from "../../hooks/useSteps"
import { useEffect, useMemo, useRef, useState } from "react"
import { ModalGanaste } from "../../components/games/ModalGanaste"
import { GoBackBtn } from "../../components/games/GoBackBtn"
import useFetch from "../../hooks/useFetch"

import { api } from "../../services/api/index"
import { useParams } from "react-router"
import { SeaAnimals } from "../../components/games/seaanimals/SeaAnimals"
import { useWindowDimensions } from "../../hooks/useWindowDimensions.js"
import { classic_coords } from "../../components/games/seaanimals/utils.js"
import { SeaAnimalsEditor } from "../../components/games/seaanimals/SeaAnimalsEditor.js"
import { ModalError } from "../../components/ui/modal/ModalError.js"

const ElegirTamano = ({ setTamano }) => {
  const dificultades = [
    { code: 6, nombre: "6x6" },
    { code: 7, nombre: "7x7" },
    { code: 8, nombre: "8x8" },
  ]

  return (
    <>
      <div className="title pt-4">Elige el tamaño de la grilla</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex justify-content-center align-items-center flex-row">
          {dificultades.map((dificultad, ix) => (
            <div key={ix} className="col-lg-4 col-6 py-1">
              <div
                className="box category"
                onClick={() => setTamano(dificultad.code)}>
                <span>
                  <b>{dificultad.nombre}</b>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

// const SeaAnimalsID = ({ id }) => {
//   const [ data, isPending, err ] = useFetch({
//     url: `${config.apiUrl}/games/${id}`
//   })

//   const showModalGanaste = useState(false)
//       , handleWin        = () => showModalGanaste[1](true)

//   if (isPending && !err)
//     return (
//       <div className="row my-5 py-5">
//         <center>
//           Cargando...
//         </center>
//       </div>
//     )

//   if (err)
//     return <NotFound />

//   return <>
//     <ModalGanaste show={showModalGanaste} />
//     {data && <CrosswordsGame
//                 data={data.entries}
//                 size={data.size}
//                 winCallback={handleWin}
//               />}
//     </>
// }

/*

'-- SeaAnimals --------'
| '-- Panel ---------' |
| | '-- Grid ------' | |
| | | '-- Cell --' | | |
| | | '----------' | | |
| | '--------------' | |
| '------------------' |
'----------------------'

*/

const SeaAnimalsLoader = ({
  size,
  animations,
  setAnimations,
  myShips,
  winCallback,
}) => {
  const { url, opt } = useMemo(
    () =>
      api.games.SeaAnimals.Generate({
        size,
      }),
    [size]
  )

  useEffect(() => {
    document.documentElement.style.setProperty("--grid-size", size)
  }, [size])

  const [data, isPending, err] = useFetch({ url, opt })

  const shipsB = [
    { len: 2, pos: { x: 1, y: 2 }, dir: "h" },
    { len: 3, pos: { x: 4, y: 0 }, dir: "v" },
    { len: 5, pos: { x: 1, y: 5 }, dir: "h" },
    { len: 4, pos: { x: 0, y: 2 }, dir: "v" },
  ]

  const coords = classic_coords(size)

  // funciones para manjear los paneles
  // e.g., bombMe(1,2) hace que el avion del panel 1 bombarde en x=1 y=2
  // onClickMe va a ser llamado cuando se clickee el panel 1
  const bombMe = useRef(null)
  const bombOp = useRef(null)
  const onClickOp = (pos) => {
    bombOp.current(pos.x, pos.y)
  }

  const onClickMe = (pos) => {
    bombMe.current(pos.x, pos.y)
  }

  const showErr = useState(true)

  if (isPending && !err)
    return (
      <div className="row my-5 py-5">
        <center>Cargando...</center>
      </div>
    )

  if (err) return <ModalError show={showErr} res={err} />

  return (
    <>
      <SeaAnimals
        size={size}
        coords={coords}
        myShips={myShips}
        opShips={shipsB}
        animations={animations}
        data={data}
        winCallback={winCallback}
        bombMe={bombMe}
        bombOp={bombOp}
        onClickMe={onClickMe}
        onClickOp={onClickOp}
      />

      <div className="row mt-4">
        <center>
          <input
            type="checkbox"
            checked={animations}
            onChange={() => setAnimations((c) => !c)}
          />
          &nbsp; Fondo animado
        </center>
      </div>
    </>
  )
}

const RandomSeaAnimalsPicker = () => {
  let [steps] = useSteps(["tamano", "config"]),
    setTamano = steps.setter("tamano"),
    setConfig = steps.setter("config")

  const { width } = useWindowDimensions(),
    defaultAnim = width >= 1366 ? true : false,
    [animations, setAnimations] = useState(defaultAnim)

  const showModalGanaste = useState(false),
    handleWin = () => {
      showModalGanaste[1](true)
    }

  return (
    <>
      <ModalGanaste show={showModalGanaste} steps={steps} />
      <GoBackBtn steps={steps} />

      {steps.at("tamano") && <ElegirTamano setTamano={setTamano} />}

      {steps.at("config") && (
        <SeaAnimalsEditor
          size={steps.data.tamano}
          setConfig={setConfig}
          animations={animations}
          setAnimations={setAnimations}
        />
      )}

      {steps.done && (
        <SeaAnimalsLoader
          size={steps.data.tamano}
          myShips={steps.data.config}
          difficulty={"easy"}
          animations={animations}
          setAnimations={setAnimations}
          winCallback={handleWin}
        />
      )}
    </>
  )
}

const SeaAnimalsViewOffline = () => {
  const { id } = useParams()

  return (
    <Container>
      {id ? (
        // ? <CrosswordsID id={id} />
        <RandomSeaAnimalsPicker />
      ) : (
        <RandomSeaAnimalsPicker />
      )}
    </Container>
  )
}

export default SeaAnimalsViewOffline
